import React from 'react'
import Mensagens from '../../../Mensagens';

class Ordenacao extends React.Component {
    
    selectField = null    

    render() {
        return <select
            fluid='true' 
            ref={(c) => this.selectField = c}
            onChange={(e) => this.onSelectChange(e.target.value)} >
            <option value='datac'  >{Mensagens.p7}</option>
            <option value='datad'  >{Mensagens.p8}</option>
            <option value='nome'  >{Mensagens.p9}</option>
            <option value='inscricoes'  >{Mensagens.p10}</option>
        </select>
    }

    onSelectChange = (value) => {
        
        if (this.props.onChangeOrder)
            this.props.onChangeOrder(value)

    }
}

export default Ordenacao


// WEBPACK FOOTER //
// ./src/components/Eventos/Pesquisa/Ordenacao.js